import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { CorpLoadingComponent, CorpDropdownComponent, CorpInputDecimalComponent } from "@corporate-tailwind/component";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { Component, computed } from "@angular/core";
import { CommonModule, NgTemplateOutlet } from "@angular/common";
import { CurrencyPurchaseService } from "./service/currency-purchase.service";
import { FormatDecimalPipe } from "src/app/shared/pipe/format-decimal.pipe";

@Component({
    selector: 'app-fp-currency-purchase',
    imports: [CommonModule, ReactiveFormsModule,  CorpDropdownComponent, CorpInputDecimalComponent, TranslateModule, RouterModule, CorpLoadingComponent, NgTemplateOutlet, FormatDecimalPipe],
    templateUrl: './fp-currency-purchase.component.html',
    styleUrl: './fp-currency-purchase.component.scss'
})
export class FpCurrencyPurchaseComponent {
form: FormGroup | null = null;

filteredListTarget = computed(() => {
    const idSource = this._currencyPurchaseService.getValue(x=>x.sourceCurrency)?.id;
    if(idSource != null){
        return this._currencyPurchaseService?.selection$()?.currency!.filter(x=>x.id !== idSource  )
    }
    return this._currencyPurchaseService?.selection$()?.currency;
});

    constructor(
        public _currencyPurchaseService: CurrencyPurchaseService
    ) {
        this.form = this._currencyPurchaseService.formGroup;
    }

    ngOnInit() {
        this._currencyPurchaseService.init();
    }

    isPurchaseDisabled(): boolean{
        return (this._currencyPurchaseService.loadingCurrencyValue$() || this._currencyPurchaseService.isAmountAlert$());
    }
}